import React from 'react';
import { styled, Box, Paper, Grid, GridProps } from '@material-ui/core';

export const DemoItem = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: 200,
  backgroundColor: '#fff',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    height: 160,
  },
}));

interface GridContainerProps extends GridProps {
  children: React.ReactNode;
}

export const GridContainer: React.FC<GridContainerProps> = ({ children, ...rest }) => (
  <Grid container spacing={4} {...rest}>
    {children}
  </Grid>
);

export const DemoGridItems: React.FC<GridProps> = ({ ...rest }) => (
  <Grid container spacing={4} {...rest}>
    <Grid item lg={8} md={12} sm={12} xs={12}>
      <DemoItem>8</DemoItem>
    </Grid>
    <Grid item lg={4} md={6} sm={6} xs={6}>
      <DemoItem>4</DemoItem>
    </Grid>
    <Grid item lg={6} md={6} sm={6} xs={6}>
      <DemoItem>6</DemoItem>
    </Grid>
    <Grid item lg={6} md={6} sm={4} xs={4}>
      <DemoItem>6</DemoItem>
    </Grid>
    <Grid item lg={4} md={6} sm={4} xs={4}>
      <DemoItem>4</DemoItem>
    </Grid>
    <Grid item lg={4} md={6} sm={4} xs={4}>
      <DemoItem>4</DemoItem>
    </Grid>
    <Grid item lg={4} md={6} sm={3} xs={3}>
      <DemoItem>4</DemoItem>
    </Grid>
    <Grid item lg={3} md={3} sm={3} xs={3}>
      <DemoItem>3</DemoItem>
    </Grid>
    <Grid item lg={3} sm={3} xs={3}>
      <DemoItem>3</DemoItem>
    </Grid>
    <Grid item lg={3} sm={3} xs={3}>
      <DemoItem>3</DemoItem>
    </Grid>
    <Grid item lg={3} md={3} sm={12} xs={12}>
      <DemoItem>3</DemoItem>
    </Grid>
  </Grid>
);

export const GridWrapper = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: 1076,
  paddingLeft: 70,
  paddingRight: 70,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 10,
    paddingRight: 10,
  },
}));
